import { atom } from 'jotai';
import z from 'zod';

import { ZTokenSchema } from '$models/state/token';

export type TokenAtom = z.infer<typeof ZTokenSchema>;

export const tokenAtom = atom<TokenAtom | undefined>(undefined);
